<template>
  <div class="bshow_wrapper">
    <div class="notice_cont_outer">
      <div class="notice_title">
        <div class="m_outer">
          <div class="m_title">企业橱窗</div>
          <div class="m_tip">
            目前共有{{ total }}家企业
          </div>
        </div>
      </div>
    </div>

    <div class="bshow_list_outer">
      <div class="cur_pos">当前位置：<span class="linkto" @click="tohome">首页</span><img
        :src="imgUrl+'double_arrow.png'"/><span>企业橱窗</span></div>

      <div class="list_cont">

        <div v-for="(item,index) in bsData" :key="index" class="bshow_item" @click="toDetail(item.id)">
          <div class="cont medium">
            <div class="img_wrapper">
              <img :src="item.logo"/>
            </div>

            <h3>
              {{ item.post_title }}
            </h3>

            <div class="p">
              {{ item.post_excerpt }}
            </div>
          </div>
        </div>

      </div>
      <el-pagination
        background
        layout="prev, pager, next,jumper"
        :current-page="currentPage"
        :page-size="pagesize"
        :total="total"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getBsList();
  },


  name: 'bshow',
  data() {
    return {
      bsData: [],
      currentPage: 1,
      pagesize: 8,
      total: 0
    }
  },
  methods: {
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getBsList();
    },
    toDetail(id) {
      this.$router.push({name: 'bsdetail', query: {id,total:this.total}})
    },
    tohome() {
      this.$router.push({name: 'homepage'})
    },
    getBsList(){
      this.$ajax.get(this.bUrl + 'api/portal/lists/corp?page='+this.currentPage+'&pagesize='+this.pagesize)
        .then(function (res) {
          this.bsData = res.data.data.list;
          this.total = res.data.data.total;
          window.localStorage.setItem('bshow_total', res.data.data.total)
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
    }

  }
}
</script>

<style scoped>
.bshow_wrapper {
  background: #fff url('http://gyzhqy.areacloud.cn/gyzhqyimgs/bshow_bg.png') no-repeat center -406px;
}

.notice_cont_outer {
  width: 1180px;
  margin: 0 auto;
  /*background: #fff url('http://gyzhqy.areacloud.cn/gyzhqyimgs/bshow_bg.png') no-repeat  -25px -150px;*/
}

.notice_title {
  height: 328px;
  display: flex;
  align-items: flex-end;
  position: relative;
}

.m_outer {
  padding: 20px;
}

.m_title {
  color: #fff;
  font-size: 28px;
  margin-bottom: 16px;
}

.m_tip {
  width: 350px;
  color: #fff;
  font-size: 14px;
  line-height: 24px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.bshow_list_outer {
  background: #fff;
}

.list_cont {
  /*padding-top: 32px;*/
  width: 1180px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}

.bshow_item {
  margin: 20px 20px;
  cursor: pointer;
}

.bshow_item .img_wrapper {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bshow_item .img_wrapper img {
  max-height: 80px;
  max-width: 180px;
}

.bshow_item h3 {
  height: 38px;
  color: #143367;
  font-size: 14px;
  text-align: center;
  margin: 10px 0 20px 0;
}

.bshow_item .p {
  font-size: 13px;
  color: #666;
  height: 83px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  /*white-space: nowrap;*/
  text-overflow: ellipsis;
}

.bshow_item .cont {
  width: 250px;
  height: 282px;
  padding: 20px 30px;
  box-sizing: border-box;
  border-radius: 10px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #E1EAFA;
  box-shadow: 0 3px 6px rgba(0, 78, 214, .16);
}
</style>



// WEBPACK FOOTER //
// src/components/BusinessShow/bshow.vue